<script>
import appConfig from '@src/app.config'
import { authComputed } from '@state/helpers'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import axios from 'axios'
import Treeselect from '@riophae/vue-treeselect'
import { LOAD_CHILDREN_OPTIONS, ASYNC_SEARCH, LOAD_ROOT_OPTIONS } from '@riophae/vue-treeselect';

export default {
	components: {
		VuePerfectScrollbar,Treeselect
	},
	props: {
		user: {
			type: Object,
			required: false,
			default: () => ({}),
		},
		isMenuOpened: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		...authComputed,
	},
	methods: 
	{
		toggleMenu() {
			this.$parent.toggleMenu();
		},
		toggleRightSidebar() {
			this.$parent.toggleRightSidebar()
		},
		UpdateNotificaionTime() 
		{

			this.totalNotifications = 0;
			if(!this.timeUpdated){
				this.timeUpdated = true;

				//update last open time
				axios.post(appConfig.api+'utilities/update_last_opentime/', {uinfo:JSON.parse(localStorage.getItem("auth.currentUser"))})
				.then((response) =>
					{
						
					})
				.catch((error) =>
				{
				});

			}
		},
		GetNotifications:function()
		{
			axios.post(appConfig.api+'utilities/notifications/', {uinfo:JSON.parse(localStorage.getItem("auth.currentUser"))})
			.then((response) =>
				{
					if(response.data)
                	{
						this.totalNotifications = response.data.total_unread;
						this.notifications = response.data.notifications;

					}
				})
			.catch((error) =>
			{
			});
		},
		getAdvertisers: function ()
		{

			var uinfo = JSON.parse(localStorage['auth.currentUser']);
			this.selected_advertiser = (typeof(uinfo.advertiser) === 'object') ? uinfo.advertiser : {};

			uinfo['advertiser'] = this.selected_advertiser;
			localStorage['auth.currentUser'] = JSON.stringify(uinfo);
			

			axios.post(appConfig.api+'advertisers/list/', {uinfo:JSON.parse(localStorage.getItem("auth.currentUser"))})
			.then((response) =>
				{
					if(response.data)
                	{
						if(response.data.code == 200){
							this.advertiser_list_loading = false;
							this.advertisers = response.data.list; 
						}
					}
				})
			.catch((error) =>
			{
			});
		},
		select_advertiser: function(advertiser)
		{
			
			var uinfo = JSON.parse(localStorage['auth.currentUser']);
			this.selected_advertiser = {name:advertiser.name,id:advertiser.id};
			uinfo['advertiser'] = this.selected_advertiser;
			localStorage['auth.currentUser'] = JSON.stringify(uinfo);

			//this.$router.push('/');
			window.location.href = '/';
			
		}
	},
	mounted: function() 
	{
     this.GetNotifications();
	 this.getAdvertisers();
  	},
	data() {
		return {
			timeUpdated:false,
			totalNotifications:0,
			notifications:[],
			advertisers:{},
			selected_advertiser:{},
			advertiser_list_loading:true
		}
	},
}
</script>

<template>
	<!-- Topbar Start -->
	<div class="navbar navbar-expand flex-column flex-md-row navbar-custom">
		<div class="container-fluid">
			<!-- LOGO -->
			<a href="/" class="navbar-brand mr-0 mr-md-2 logo">
				<span class="logo-lg">
					<object type="image/svg+xml" style="max-width: 130px;height: 35px;pointer-events: none;" data="https://www.foxpush.com/images/foxpush_logo_multicolor.svg"></object>				
					</span>
				<span class="logo-sm">
					<img src="@assets/images/logo.png" alt height="24" />
				</span>
			</a>

			<ul
				class="navbar-nav bd-navbar-nav flex-row list-unstyled menu-left mb-0"
			>
				<li class>
					<button
						class="button-menu-mobile open-left disable-btn"
						:class="{ open: isMenuOpened }"
						@click="toggleMenu"
					>
						<feather type="menu" class="menu-icon align-middle"></feather>
						<feather type="x" class="close-icon"></feather>
					</button>
				</li>
			</ul>


			<div class="advertiser_select">
				
				
				<b-dropdown variant="link" class="scrollable-menu">
					
					<template slot="button-content">
						<span style="color:gray;">Advertiser: </span>
						
						<span style="color: red;font-weight: bold;" v-if="selected_advertiser.name === undefined">No Advertiser Selected</span>

						<span style="color: orange;font-weight: bold;" v-if="!advertisers.length && advertiser_list_loading == false">You don't have any active advertisers</span>

						<span v-if="selected_advertiser.name !== undefined">{{selected_advertiser.name}}</span>
						
						<i class="uil uil-angle-down"></i>
					</template>
					
					<b-dropdown-item v-for="advertisr in advertisers" @click="select_advertiser(advertisr);">{{advertisr.name}}</b-dropdown-item>
					
					
					<b-dropdown-item v-if="advertiser_list_loading" disabled>Please wait we are loading the list.</b-dropdown-item>
					
				</b-dropdown>
			</div>

			<ul class="navbar-nav flex-row ml-auto d-flex list-unstyled topnav-menu float-right mb-0">

				<b-nav-item-dropdown id="bell-notification" right variant="white" class="notification-list" menu-class="dropdown-lg">
					<template v-slot:button-content>
						<feather type="bell" v-on:click="UpdateNotificaionTime" class="align-middle"></feather>
						<span class="noti-icon-badge" v-if="totalNotifications != 0" v-on:click="UpdateNotificaionTime"></span>
					</template>
					
					<b-tooltip target="bell-notification" placement="left">{{totalNotifications}} new unread notifications</b-tooltip>
					<!-- item-->
					<b-dropdown-text class="noti-title border-bottom pb-2" tag="div">
						<h5 class="m-0 font-size-16">
							<span class="float-right"></span>Notifications
						</h5>
					</b-dropdown-text>

					<VuePerfectScrollbar class="noti-scroll">
						<!-- item-->
						<b-dropdown-text v-for="msg of notifications" :key="msg.id" class="notify-item border-bottom">
							<div class="notify-icon bg-primary">
								<i class="uil" v-bind:class="msg.icon"></i>
							</div>
							<p class="notify-details">
								{{msg.message}}
								<small class="text-muted">{{msg.date}}</small>
							</p>
						</b-dropdown-text>

						<div v-if="!notifications.length">
							<p class="notify-details text-center">
								No new messages.
							</p>
						</div>

					</VuePerfectScrollbar>

				</b-nav-item-dropdown>


			</ul>
		</div>
	</div>
	<!-- end Topbar -->
</template>

<style lang="scss">
.noti-scroll {
	height: 220px;
}
.ps > .ps__scrollbar-y-rail {
	width: 8px !important;
	background-color: transparent !important;
}
.ps > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps.ps--in-scrolling.ps--y > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:active > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:hover > .ps__scrollbar-y {
	width: 6px !important;
}
.button-menu-mobile {
	outline: none !important;
}
</style>
